import type { ReactNode } from 'react';

export const symbol_sentiment_very_satisfied: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-261q57 0 105.5-26t78.5-72q6-12-.5-23T643-393H317q-14 0-20.5 11t-.5 23q30 46 78.5 72T480-261ZM347-578l27 27q8 8 18 8t18-8q8-8 8-18t-8-18l-42-42q-9-9-21-9t-21 9l-42 42q-8 8-8 18t8 18q8 8 18 8t18-8l27-27Zm267 0 27 27q8 8 18 8t18-8q8-8 8-18t-8-18l-42-42q-9-9-21-9t-21 9l-42 42q-8 8-8 18t8 18q8 8 18 8t18-8l27-27ZM324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM480-480Zm241 241q99-99 99-241t-99-241q-99-99-241-99t-241 99q-99 99-99 241t99 241q99 99 241 99t241-99Z"
		/>
	</svg>
);
